<template>
  <div
    class="flex flex-row justify-between items-center w-full py-3 px-2 md:px-0"
    :class="addPointer()"
    @click="goTo()"
  >
    <div class="setting flex flex-row items-center">
      <i :class="iconClass" class="text-lg text-blue" v-if="iconClass" />
      <p class="text-sm pl-1">
        <slot />
      </p>
    </div>

    <div class="switch" v-if="hasToggle">
      <bdg-toggle :id="toggleId" />
    </div>
  </div>
</template>

<script>
import BdgToggle from "../../../forms/fields/BdgToggle";

export default {
  name: "SettingsCell",
  components: { BdgToggle },
  props: {
    iconClass: { type: String, required: false },
    hasToggle: { type: Boolean, default: false },
    toggleId: { type: String, required: false },
    linksTo: { type: Object, required: false }
  },
  methods: {
    goTo() {
      if (!this.linksTo) {
        return;
      }

      this.$router.push(this.linksTo);
    },
    addPointer() {
      if (this.linksTo) {
        return "pointer";
      }

      return "";
    }
  }
};
</script>

<style scoped></style>
